export default ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','ES','IE','LT','LU','LV','MT','NL','DE','PT','RO','SK','SI','SE','HU','GB','IT'];
